<template>
	<div class="organization-release-note-form">
		<div class="organization-release-note-form__content">
			<p class="organization-release-note-form__subtitle">Comment souhaitez-vous nommer votre organisation ?</p>

			<o-input
				v-model="setup.organization.title"
				:donetyping="600"
				autofocus
				label="Nom de votre organisation (3 caractères min.)"
				:validation="setup.validator.rule('title')"
				@input="setup.generateAndVerifyMailAsync($event)"/>

			<o-alert
				v-if="setup.errorMessage"
				class="text--pre-line"
				color="danger">
				{{ setup.errorMessage }}
			</o-alert>

			<o-alert>
				<p>
					Vous l'aurez compris, <b>l'organisation</b> que vous vous apprêtez à créer
					rassemblera dorénavant <b>vos sociétés et vos utilisateurs</b>.
				</p>
				Si vous êtes en manque d'inspiration, vous pouvez toujours saisir le nom de votre <b>groupe, holding ou raison sociale</b> 😉
			</o-alert>

			<o-input
				v-model="setup.organization.mail"
				label="Adresse mail associée"
				disabled/>

			<o-alert color="info">
				<p>L'adresse mail associée est <b>automatiquement générée</b> suivant le nom de votre organisation.</p>
				<p v-if="setup.self.isClient()">
					Elle va devenir <b>l'identifiant unique</b> qui vous permettra de travailler sur une seule et même organisation
					avec <b>vos agences partenaires</b> !
					<br>
					Une fois créée, nous vous donnerons la possibilité de <b>partager</b> cette adresse avec vos agences actuelles et à venir 🎉
				</p>
				<p v-else>
					Vos clients, qui vont également passer par cette étape de création d'organisation pour leurs propres sociétés, devront
					<b>vous communiquer cette adresse mail</b> afin de faciliter les échanges actuels et à venir !
				</p>
			</o-alert>
		</div>

		<teleport to="#organization-release-note-additional-action">
			<o-button
				block
				color="info"
				:loading="setup.checking"
				prefix-font-icon="icon-interface-validation-check"
				@click="setup.createOrganizationAsync()">
				Créer
			</o-button>
		</teleport>
	</div>
</template>

<script setup lang="ts">
import OrganizationReleaseNoteFormSetupService from '@/setup/organization/OrganizationReleaseNoteFormSetupService';
const setup = new OrganizationReleaseNoteFormSetupService();
</script>

<style scoped lang="less">
.organization-release-note-form {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &__content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1.5rem;

    > * {
      margin: 0;
    }
  }
}
</style>
